module.exports = __webpack_public_path__ + "static/img/brand-third-6.5f28ec9d.png";